<template>
  <div class="content-block-spacer">
    <img :src="`${useCdnUrl()}/assets/icons/arrow-dots.png`" />
  </div>
</template>

<style lang="scss">
.content-block-spacer {
  background-color: white;
  padding: 1rem 0 0.5rem 0;
  text-align: center;
}
</style>
